import { Homologacao } from './homologacao';


export class HomologacaoCapacitadora extends Homologacao {
    public id_capacitadora: number;
    contador: any;
    possui_autonomia: boolean;
}



// WEBPACK FOOTER //
// ./src/app/entity/homologacao-capacitadora.model.ts